import React from "react";
import PropTypes from "prop-types";
import styles from "./CheckList.module.css";
import CheckListItem from "../CheckListItem";

/**
 * A list item that contains a category of filter conditions for the feed list. 
 */
export function CheckList({
  categoryTitle,
  categoryOptions,
  checkedOptions,
  setCheckedOptions,
}) {
  // return <div>
  //   <div className={styles.title}>{categoryTitle}</div>
  //   {categoryOptions.map((option) => (
  //     <div className={styles.item}><CheckListItem itemTitle={option} isChecked={(checkedOptions && checkedOptions.indexOf(option) > -1) ? true : false} onClick={() => setCheckedOptions(option)}/></div>
  //   ))}
    
  // </div>;

  // Fix key prop error
  return (
    <div>
      <div className={styles.title}>{categoryTitle}</div>
      {categoryOptions.map((option) => (
        <div key={option} className={styles.item}>
          <CheckListItem
            itemTitle={option}
            isChecked={checkedOptions && checkedOptions.indexOf(option) > -1}
            onClick={() => setCheckedOptions(option)}
          />
        </div>
      ))}
    </div>
  );
}

CheckList.propTypes = {
  // /**
  //  * Label
  //  */
  // categoryTitle: PropTypes.string,
  // /**
  //  * Checkbox options
  //  */
  // categoryOptions: PropTypes.bool,
  // /**
  //  * An array of checkbox values that are currently checked.
  //  */
  // checkedOptions: PropTypes.func,
  // /**
  //  * Function that controls the value of the selected checkboxes
  //  */
  // setCheckedOptions: PropTypes.func,

  // Clean up PropTypes
  categoryTitle: PropTypes.string.isRequired,
  categoryOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  checkedOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  setCheckedOptions: PropTypes.func.isRequired,
};
